<mat-toolbar color="primary">
  <span id="oppgave-opprett-dialog-tittel">
    @switch (modus) {
      @case ('sak') {
        {{ "Ny oppgave under sak"|translate }}
      }
      @case ('beslutning') {
        {{ "Ny oppgave under beslutning"|translate }}
      }
      @case ('gruppe') {
        {{ "Ny oppgave"|translate }}
      }
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<form [formGroup]="skjema" (ngSubmit)="opprett()">
  <mat-dialog-content class="skjema">
    @if (modus == 'gruppe') {
      <fieldset>
        <mat-form-field class="gruppe">
          <mat-label>{{ 'Gruppe'|translate }}</mat-label>
          <velg-gruppe [skjemakontroll]="skjema.controls.gruppe" [grupper]="tilgjengeligeGrupper()"/>
        </mat-form-field>
      </fieldset>
    }
    <oppgave-skjema [skjema]="skjema.controls.oppgave" [gruppeId]="gruppeId()"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial
            [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()"
            spinnerTekst="{{'Oppretter...'|translate}}" data-testid="oppgave-lagre">
      {{ 'Opprett'|translate }}
    </button>
  </mat-dialog-actions>
</form>
